import React__default from 'react';
import './Note.scss';

const Note = ({ children }) => (React__default.createElement("div", { className: 'note--rev' }, children));

export { Note };
//# sourceMappingURL=Note.js.map
